import React from 'react';

// parts
import HtmlPart from '../../../parts/HtmlPart';

export default function({ text }) {
  return (
    <div className="card-content-color__greyBg  c-html-part  c-html-part__recommend  u-padding-medium">
      <HtmlPart htmlString={text} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/cards/templates/RecommendAFriendCard/Confirmation.js